(ns kyber.components.composite.resource
  (:require [clojure.string :refer [includes?]]
            [re-frame.core :as re-frame]

            [kyber.styles.core :refer [gs styles->classes]]
            [kyber.constants :refer [base-api-url]]))

(def classes
  (styles->classes
   {:resource-class
    {:max-width "100%"
     :font-family (gs [:font-family :open-sans])
     :font-size "small"

     (gs [:queries :ie])
     {:width "100%"
      :height "100%"}}}))

(defn src-url [src token]
  (when (some? src)
    (str base-api-url
         src
         (if (includes? src "?") "&" "?")
         "token=" token)))

(defn get-source
  [url]
  (src-url url @(re-frame/subscribe [:authentication/session-token])))

(defn resource
  [_]
  (let [token (re-frame/subscribe [:authentication/session-token])]
    (fn [{:keys [tag src alt class style]
         :or {style {}}}]

      (case tag
        :img
        [tag (cond-> {:src (src-url src @token)
                      :alt alt
                      :class (:resource-class classes)
                      :style style}

               (some? class)
               (update :class str " " class))]

        (js/console.error "Tag type not supported")))))
